import axioscommon from './axios-common';
import authHeader from './auth-header';

const defaultSettings = require('@/settings.js');
const API_URL = defaultSettings.apiUrl + '/api/priority/';

class PriorityService {
    getPriorities(onlyActive) {
        if (onlyActive) {
            return axioscommon.get(API_URL, { headers: authHeader() });
        }
        return axioscommon.get(API_URL + 'getAll', { headers: authHeader() });
    }

    savePriority(data) {
        return axioscommon.post(API_URL, data, { headers: authHeader() });
    }
    updatePriority(data) {
        return axioscommon.put(API_URL, data, { headers: authHeader() });
    }
}

export default new PriorityService();
